export enum LocalStorageKeysEnum {
  INVITATION_ID = 'invitation_id',
}
